
export default () => {
  return window.innerWidth < 1024 ? true : false
}